/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: refactor
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { DragSection } from './components/DragSection';
import { FilesList } from './components/FilesList';
import { InfoLink } from './components/InfoLink';
import { UnsupportedFiles } from './components/UnsupportedFiles';

import './UploadField.sass';

export const UploadField = (props) => {
  const { files, infoText, name, formik, infoLink } = props;

  const [unsupportedFilesCount, setUnsupportedFilesCount] = useState(0);

  const setFiles = (newFiles) => formik.setFieldValue(name, newFiles);

  const onFileRemove = (index) => {
    const newFiles = files.filter((_, iindex) => iindex !== index);
    setFiles([...newFiles]);
  };

  return (
    <div className="form-upload__wrapper">
      {infoText && (
        <div className="info-text">
          {infoText}
          <InfoLink infoLink={infoLink} />
        </div>
      )}

      <DragSection
        files={files}
        setFiles={setFiles}
        setUnsupportedFilesCount={setUnsupportedFilesCount}>
        <FilesList files={files} onFileRemove={onFileRemove} />
      </DragSection>

      <UnsupportedFiles unsupportedFilesCount={unsupportedFilesCount} />
    </div>
  );
};
UploadField.propTypes = {
  infoText: PropTypes.node,
  name: PropTypes.string,
  files: PropTypes.array.isRequired,
  formik: PropTypes.object,
  infoLink: PropTypes.string,
};

UploadField.defaultProps = {
  infoText: null,
  name: '',
  formik: null,
  infoLink: null,
};
